export function SpaceHUD() {
  return (
    <div class="absolute inset-0 pointer-events-none p-6 flex flex-col justify-between text-cyan-400 font-mono select-none overflow-hidden">
      
      {/* Top Bar: Status */}
      <div class="flex justify-between items-start">
        {/* Top Left: Power Distribution (Mock) */}
        <div class="bg-black/40 backdrop-blur p-4 rounded-lg border border-cyan-500/30 w-64">
          <h3 class="text-sm font-bold mb-2 opacity-70">POWER DISTRIBUTION</h3>
          <div class="space-y-2 text-xs">
            <div class="flex items-center gap-2">
              <span class="w-8">SYS</span>
              <progress id="hud-power-sys" class="progress progress-info flex-1 h-2" value="100" max="100"></progress>
            </div>
            <div class="flex items-center gap-2">
              <span class="w-8">ENG</span>
              <progress id="hud-power-eng" class="progress progress-warning flex-1 h-2" value="100" max="100"></progress>
            </div>
            <div class="flex items-center gap-2">
              <span class="w-8">WEP</span>
              <progress id="hud-power-wep" class="progress progress-error flex-1 h-2" value="100" max="100"></progress>
            </div>
          </div>
        </div>

        {/* Top Right: Shields / Hull */}
        <div class="bg-black/40 backdrop-blur p-4 rounded-lg border border-cyan-500/30 w-80 text-right">
          <div class="mb-4">
            <div class="flex justify-between text-sm mb-1">
               <span>SHIELDS</span>
               <span id="hud-shield-text">100%</span>
            </div>
            <progress id="hud-shield" class="progress progress-primary w-full h-3" value="100" max="100"></progress>
          </div>
          <div>
            <div class="flex justify-between text-sm mb-1">
               <span>HULL INTEGRITY</span>
               <span id="hud-hull-text">100%</span>
            </div>
            <progress id="hud-hull" class="progress progress-error w-full h-3" value="100" max="100"></progress>
          </div>
        </div>
      </div>

      {/* Top Center: Mission Clock */}
      <div class="absolute top-0 left-1/2 -translate-x-1/2 flex flex-col items-center z-10">
          <div class="bg-black/40 backdrop-blur px-8 py-3 rounded-b-xl border-x border-b border-cyan-500/30 text-center shadow-[0_0_20px_rgba(0,255,255,0.1)]">
             <div class="text-[9px] tracking-[0.3em] text-cyan-400/50 mb-1 font-bold">UTC / SYSTEM TIME</div>
             <div id="hud-clock" class="text-3xl font-bold text-white font-mono tracking-widest leading-none drop-shadow-[0_0_5px_rgba(255,255,255,0.5)]">00:00:00</div>
             <div id="hud-date" class="text-xs text-cyan-200 font-mono mt-1 tracking-widest opacity-80">1999.01.01</div>
          </div>
      </div>

      {/* Earth Indicator */}
      <div id="hud-earth-indicator" class="absolute pointer-events-none flex flex-col items-center" style="display: none; left: 0; top: 0;">
          <div id="hud-earth-arrow" class="text-4xl text-blue-500 font-bold transition-transform duration-100 drop-shadow-lg" style="transform-origin: center;">
             ▲
          </div>
          <div id="hud-earth-label" class="mt-1 text-xs font-bold bg-black/60 px-2 py-1 rounded text-blue-200 border border-blue-500/30 whitespace-nowrap">
              EARTH
              <br/>
              <span id="hud-earth-dist">0 km</span>
          </div>
      </div>

      {/* Sun Indicator */}
      <div id="hud-sun-indicator" class="absolute pointer-events-none flex flex-col items-center" style="display: none; left: 0; top: 0;">
          <div id="hud-sun-arrow" class="text-4xl text-yellow-500 font-bold transition-transform duration-100 drop-shadow-lg" style="transform-origin: center;">
             ▲
          </div>
          <div id="hud-sun-label" class="mt-1 text-xs font-bold bg-black/60 px-2 py-1 rounded text-yellow-200 border border-yellow-500/30 whitespace-nowrap">
              SUN
              <br/>
              <span id="hud-sun-dist">0 km</span>
          </div>
      </div>

      {/* Moon Indicator */}
      <div id="hud-moon-indicator" class="absolute pointer-events-none flex flex-col items-center" style="display: none; left: 0; top: 0;">
          <div id="hud-moon-arrow" class="text-4xl text-gray-300 font-bold transition-transform duration-100 drop-shadow-lg" style="transform-origin: center;">
             ▲
          </div>
          <div id="hud-moon-label" class="mt-1 text-xs font-bold bg-black/60 px-2 py-1 rounded text-gray-200 border border-gray-500/30 whitespace-nowrap">
              MOON
              <br/>
              <span id="hud-moon-dist">0 km</span>
          </div>
      </div>

      {/* Center: Crosshair is handled by CSS in room.tsx already, or we can move it here */}
      
      {/* Bottom Bar: Flight Data */}
      <div class="flex justify-between items-end">
        {/* Bottom Left: Speed */}
        <div class="bg-black/40 backdrop-blur p-6 rounded-full border border-cyan-500/30 w-48 h-48 flex flex-col items-center justify-center relative overflow-hidden">
             {/* Decor */}
             <div class="absolute inset-0 border-4 border-cyan-900/50 rounded-full border-t-cyan-400/80 animate-spin-slow"></div>
             
             <span class="text-xs opacity-50 mb-1">VELOCITY</span>
             <span id="hud-speed" class="text-5xl font-bold text-white tracking-widest">0</span>
             <span class="text-xs opacity-50 mt-1">m/s</span>
        </div>

        {/* Bottom Right: Weapons */}
        <div class="bg-black/40 backdrop-blur p-4 rounded-lg border border-cyan-500/30 w-64">
           <div class="flex justify-between items-center mb-2">
               <span class="text-sm font-bold">WEAPONS ACTIVE</span>
               <div class="text-xs font-mono text-orange-400 font-bold">AIM: <span id="hud-aim-dist">600m</span></div>
           </div>
           {/* Mock Weapon Slots */}
           <div class="grid grid-cols-3 gap-2">
               <div class="aspect-square bg-cyan-900/30 border border-cyan-500/50 flex items-center justify-center text-xs">
                   WING
               </div>
               <div class="aspect-square bg-purple-900/30 border border-purple-500/50 flex items-center justify-center text-xs">
                   TOP
               </div>
               <div class="aspect-square bg-red-900/30 border border-red-500/50 flex items-center justify-center text-xs">
                   BTM
               </div>
           </div>
        </div>
      </div>
    </div>
  );
}
